export const articles = [
  {
    id: "music-festival-rain",
    title: "音乐节突遇暴雨临时改期：数万观众有序撤离现场",
    excerpt:
      "傍晚突降暴雨，主办方在开演前一小时宣布改期。现场广播、志愿者与数万观众之间，究竟发生了什么？",
    category: "star-scene",
    categoryName: "明星现场",
    author: "现场观察员 · 林晚",
    publishDate: "2026-08-18",
    readTime: "6 分钟",
    views: 128400,
    hot: true,
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20outdoor%20music%20festival%20crowd%20at%20dusk%20under%20dramatic%20stormy%20sky%20with%20golden%20stage%20lights%2C%20blurred%20silhouettes%2C%20editorial%20photojournalism%20mood%2C%20crimson%20and%20amber%20tones%2C%20soft%20bokeh%2C%20high%20detail&width=1200&height=800&seq=kldg-cover-01&orientation=landscape",
    tags: ["音乐节", "现场直击", "突发改期"],
    content: [
      "傍晚六点二十，天空忽然暗了下来。距离当晚主舞台开演还有一个多小时，第一阵雨点落在观演区外的遮阳棚上，人群里先是一阵骚动，随后又安静下来，等待着大屏幕给出说法。",
      "六点四十五分，主办方通过现场广播与官方账号同步发布消息：受持续强对流天气影响，当晚演出临时改期。公告发布后，入口处的工作人员迅速切换为引导模式，将观众按区域分流到三个有遮挡的集散点。",
      "现场目击者描述，撤离过程总体有序。志愿者手持荧光引导牌，沿主通道反复播放路线提示；不少前排观众主动帮后排的人收拾野餐垫和折叠椅。一位从外地赶来的观众说，虽然遗憾，但广播反复提醒“安全第一”，大家情绪都还算平稳。",
      "截至当晚九点，场内观众基本完成疏散。主办方表示，改期后的具体演出时间将在天气条件确认后另行通知，已购票观众可选择全额退票或保留原票。",
    ],
    timeline: [
      { time: "18:20", text: "场地突降阵雨，观众区开始出现小范围移动。" },
      { time: "18:45", text: "主办方发布临时改期公告，启动分区疏散预案。" },
      { time: "19:30", text: "三个集散点完成分流，接驳车班次加密。" },
      { time: "21:00", text: "场内观众基本疏散完毕，退票通道开启。" },
    ],
  },
  {
    id: "drama-press-conference",
    title: "新剧发布会话筒失灵，主创临场清唱救场全场沸腾",
    excerpt:
      "发布会进行到一半，话筒突然没了声音。主创没有等待，而是拿起清唱救场——这段画面很快传遍网络。",
    category: "screen",
    categoryName: "影视野台",
    author: "编辑 · 周晴",
    publishDate: "2026-08-22",
    readTime: "5 分钟",
    views: 96230,
    hot: true,
    featured: true,
    cover:
      "https://readdy.ai/api/search-image?query=Warm-toned%20abstract%20press%20conference%20stage%20with%20an%20empty%20microphone%20stand%20under%20golden%20spotlights%2C%20blurred%20audience%20silhouettes%2C%20editorial%20news%20photography%20style%2C%20amber%20and%20deep%20red%20palette%2C%20soft%20focus%20background&width=1200&height=800&seq=kldg-cover-02&orientation=landscape",
    tags: ["发布会", "临场救场", "原创剧集"],
    content: [
      "发布会进行到主创互动环节时，前排话筒突然没了声音。现场工作人员紧急排查，台下传来零星的笑声。就在短暂冷场的十几秒里，台上的主创拿起备用话筒，先清唱了剧中的一段插曲。",
      "这一唱，气氛立刻变了。起初只是前排跟着打节拍，很快后排也加入进来，整场发布会变成了一个临时的合唱现场。有媒体同行形容，那一刻“比任何预告片都更像一部剧的开场”。",
      "技术问题在几分钟后解决。主创在随后的采访中表示，当时并没有多想，“台下坐了几个小时，我不想让他们干等”。至于是否会成为正式宣传素材，片方回应称“还在讨论”。",
      "当晚，这段清唱视频在多个平台被大量转发，不少网友留言称被这份临场应对打动，也有人开始搜索这部剧的正式上线时间。",
    ],
    timeline: [
      { time: "15:10", text: "发布会进入主创互动环节。" },
      { time: "15:26", text: "前排话筒突发故障，现场短暂冷场。" },
      { time: "15:28", text: "主创临场清唱，全场跟随打拍。" },
      { time: "15:35", text: "设备恢复，活动正常继续。" },
    ],
  },
  {
    id: "night-market-stall",
    title: "夜市摊主意外走红：游客排队三小时只为一口热汤",
    excerpt: "一段十几秒的短视频让这个小摊位被挤爆了，摊主却说“我只想安安稳稳把汤熬好”。",
    category: "city",
    categoryName: "城市现场",
    author: "通讯员 · 陈屿",
    publishDate: "2026-08-25",
    readTime: "4 分钟",
    views: 74510,
    hot: false,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20night%20market%20street%20with%20glowing%20amber%20food%20stalls%20and%20steam%20rising%2C%20blurred%20crowd%20of%20visitors%2C%20cozy%20cinematic%20editorial%20photography%2C%20golden%20and%20crimson%20tones%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=kldg-cover-03&orientation=landscape",
    tags: ["夜市", "走红", "城市烟火"],
    content: [
      "视频里只有十几秒：一口大锅冒着白汽，摊主舀汤、撒葱、递碗，动作利落。就是这样一段没有旁白的画面，让这个开了七年的小摊在一周内被更多人知道。",
      "走红之后，排队的人从原来的几分钟变成了三个小时。摊主在接受采访时显得有些无奈，反复说“汤要慢慢熬，快不了”。为了保证出品，他把每日的备料量做了限制，售完即止。",
      "周边的摊主也受到了带动。一位卖糖水的阿姨说，最近傍晚的人流明显多了，“大家都是冲着热汤来的，顺便也会买点别的”。当地夜市管理方表示，已加派人手疏导人流并增设临时垃圾桶。",
      "谈到这股热度，摊主的态度很平静：“火不火都行，我只想安安稳稳把汤熬好。”",
    ],
  },
  {
    id: "marathon-supply",
    title: "马拉松补给站物资疑遭哄抢？组委会公布完整监控",
    excerpt: "一段模糊视频引发争议，组委会随后公布了补给站全时段监控，还原了事情经过。",
    category: "city",
    categoryName: "城市现场",
    author: "记者 · 苏木",
    publishDate: "2026-08-28",
    readTime: "6 分钟",
    views: 58320,
    hot: false,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20city%20marathon%20scene%20at%20sunrise%20with%20runner%20silhouettes%20and%20orange%20water%20station%20tents%2C%20warm%20golden%20light%2C%20editorial%20sports%20photojournalism%2C%20amber%20and%20red%20palette%2C%20soft%20bokeh&width=1200&height=800&seq=kldg-cover-04&orientation=landscape",
    tags: ["马拉松", "补给站", "赛事组织"],
    content: [
      "赛事当天下午，一段画质模糊的视频在社交平台流传，画面中有人快速搬走补给站成箱的物资，配文称“补给站被哄抢”。该内容在短时间内引发大量讨论。",
      "当晚，组委会发布情况说明，并附上补给站从搭建到撤场的完整监控。监控显示，视频中搬箱的人员佩戴工作证，为志愿者在按计划转移备用物资，并非哄抢。",
      "组委会同时说明了当天的物资投放节奏：起跑后每小时补充一批，因部分跑者集中在特定时段经过，个别补给点曾出现短暂的饮用水短缺，工作人员在两小时内完成了补货。",
      "多位参赛跑者也在评论区补充了现场情况。一位完赛选手写道，自己在两个补给点之间确实遇到过缺水，但志愿者一直在提醒“前面一站有”。组委会表示，下一届将优化投放点位与数量测算。",
    ],
    timeline: [
      { time: "06:30", text: "各补给站完成首轮物资投放。" },
      { time: "09:15", text: "个别补给点出现短暂饮用水短缺。" },
      { time: "11:00", text: "备用物资转移到位，供应恢复。" },
      { time: "19:40", text: "组委会发布情况说明与监控视频。" },
    ],
  },
  {
    id: "band-reunion",
    title: "老牌乐队宣布重组巡演，首站门票十分钟售罄",
    excerpt: "沉寂多年之后，这支乐队用一场巡演宣告回归，首站开票十分钟即告售罄。",
    category: "star-scene",
    categoryName: "明星现场",
    author: "编辑 · 周晴",
    publishDate: "2026-09-01",
    readTime: "5 分钟",
    views: 88340,
    hot: true,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20concert%20stage%20with%20dramatic%20golden%20beams%20and%20silhouetted%20musicians%2C%20smoke%20haze%2C%20cinematic%20live%20music%20atmosphere%2C%20amber%20and%20crimson%20color%20grading%2C%20high%20contrast%20editorial%20style&width=1200&height=800&seq=kldg-cover-05&orientation=landscape",
    tags: ["乐队", "巡演", "重组"],
    content: [
      "时隔多年，这支被许多乐迷反复提起的乐队在社交平台发布了同一张舞台背影照，配文只有四个字：我们回来了。消息发布当天，相关话题阅读量迅速攀升。",
      "巡演首站定于一座中型场馆。开票十分钟后，主办方宣布售罄，并紧急追加一场。乐队在后续的语音留言中表示，排练已经在进行，“有些歌重新编了，但你会听出来的”。",
      "不少老乐迷在评论区分享了自己第一次听到这支乐队的年份，也有人晒出保存多年的演出票根。乐队主创回应称，看到这些“有点想哭”。",
      "主办方提示，后续场次的开票信息将通过官方渠道公布，请勿轻信非官方的转票渠道。",
    ],
  },
  {
    id: "athlete-tears",
    title: "运动员赛后采访意外落泪，教练组深夜回应训练调整",
    excerpt: "一段赛后采访让无数人破防，教练组随后说明了近期的训练安排与恢复计划。",
    category: "sports",
    categoryName: "赛事直击",
    author: "赛事观察员 · 高野",
    publishDate: "2026-09-03",
    readTime: "5 分钟",
    views: 66210,
    hot: false,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Warm-toned%20sports%20stadium%20under%20evening%20floodlights%20with%20empty%20track%20and%20blurred%20crowd%2C%20dramatic%20amber%20glow%2C%20editorial%20sports%20photography%20mood%2C%20crimson%20accents%2C%20soft%20focus&width=1200&height=800&seq=kldg-cover-06&orientation=landscape",
    tags: ["赛事", "赛后采访", "训练调整"],
    content: [
      "比赛结束后的混合采访区，这位运动员在回答第三个问题时情绪忽然有些绷不住。她停顿了一下，说了句对不起，然后笑着把话说完。",
      "这段采访很快被大量转发。教练组在深夜通过官方渠道回应，表示近期确实对训练计划做了调整，主要方向是“把节奏放慢一点，把状态留在正赛”。",
      "教练组同时说明，队员的身体指标一切正常，落泪更多来自长期积压的压力释放。“她对自己要求一直很高，这次我们更希望她放下包袱。”",
      "不少网友留言称，比起成绩，更希望看到运动员被善待。赛事方也提醒观众，理性看待胜负，把掌声送给每一位站上赛场的人。",
    ],
  },
  {
    id: "internet-meme",
    title: "一句口误引爆全网二创，当事人回应：没想到会这么火",
    excerpt: "直播里的一句口误，成了这几天最热门的网络梗。源头当事人本人也出面回应了。",
    category: "internet",
    categoryName: "网络风云",
    author: "编辑 · 小满",
    publishDate: "2026-09-05",
    readTime: "4 分钟",
    views: 152300,
    hot: true,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20warm-toned%20digital%20screen%20glow%20with%20blurred%20social%20media%20interface%20shapes%20and%20amber%20reflections%2C%20moody%20cinematic%20editorial%20style%2C%20deep%20red%20and%20gold%20palette%2C%20soft%20bokeh&width=1200&height=800&seq=kldg-cover-07&orientation=landscape",
    tags: ["网络热梗", "二创", "直播"],
    content: [
      "事情发生在一次普通的直播里。嘉宾在介绍产品时把两个词说反了，自己先笑了出来。这一段被剪成十几秒的片段，很快出现在各个平台的首页。",
      "接下去的两天，这个口误被做成了各种版本：有人配上背景音乐，有人画成表情包，还有人把它编进了短剧。相关话题连续多日占据热榜。",
      "当事人随后在账号上回应：“一开始有点慌，后来发现大家都是善意的，就放心了。真的没想到会这么火。”他还顺手玩了一次自己的梗。",
      "有传播研究者分析，这段内容之所以出圈，是因为它足够日常、没有攻击性，谁都能参与进来。",
    ],
  },
  {
    id: "film-premiere",
    title: "电影首映礼红毯临时改道，粉丝与安保达成默契",
    excerpt: "因为现场人流超出预期，红毯临时改道绕行。一次小小的调整，被现场观众记录了下来。",
    category: "screen",
    categoryName: "影视野台",
    author: "记者 · 苏木",
    publishDate: "2026-09-06",
    readTime: "4 分钟",
    views: 43980,
    hot: false,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Warm-toned%20abstract%20red%20carpet%20premiere%20scene%20with%20golden%20bokeh%20lights%20and%20blurred%20silhouettes%2C%20elegant%20cinematic%20editorial%20photography%2C%20amber%20and%20crimson%20palette%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=kldg-cover-08&orientation=landscape",
    tags: ["首映礼", "红毯", "现场秩序"],
    content: [
      "首映礼原定于晚上七点开始入场。六点半刚过，影厅外的围观人群已经远远超过场地既有的动线容量。",
      "主办方与安保团队临时决定，让嘉宾车队改由侧门进入，红毯环节则挪到内场的小型展示区。现场广播同步向围观人群说明情况，并引导大家前往外场的大屏观礼区。",
      "一位在现场的影迷说，虽然没能近距离看到演员，但工作人员一直在解释，“态度挺好，大家也就理解了”。整场活动比原计划晚了约二十分钟。",
      "片方在活动结束后致谢观众，并表示会在后续路演中增加内场名额，回馈到场等待的影迷。",
    ],
  },
  {
    id: "charity-concert",
    title: "公益演唱会加演一场，票款去向公示引发讨论",
    excerpt: "加演消息公布的同时，主办方公开了上一场票款的使用明细，评论区随即热闹起来。",
    category: "star-scene",
    categoryName: "明星现场",
    author: "编辑 · 周晴",
    publishDate: "2026-09-08",
    readTime: "5 分钟",
    views: 51760,
    hot: false,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20charity%20concert%20hall%20with%20golden%20stage%20lights%20and%20blurred%20seated%20audience%2C%20cinematic%20editorial%20atmosphere%2C%20amber%20and%20soft%20red%20tones%2C%20gentle%20haze%2C%20high%20detail&width=1200&height=800&seq=kldg-cover-09&orientation=landscape",
    tags: ["公益", "演唱会", "票款公示"],
    content: [
      "这场公益演唱会原本只安排了一场，开票后很快售罄。主办方随后宣布加演，并承诺加演场次的全部票款将一并纳入公益项目。",
      "和加演消息一同发布的，还有上一场票款的使用明细：场租、舞台搭建、运输与保险费用逐项列出，结余部分注明将用于资助项目。表格被不少网友称为“看得懂的公示”。",
      "也有观众提出疑问，希望公开更细的采购凭证。主办方回应称，将在项目结项后统一发布完整报告，并邀请第三方机构参与核对。",
      "参与演出的艺人也在社交平台转发公示链接，呼吁大家理性监督。“把每一分钱说清楚，才对得起买票的人。”",
    ],
  },
  {
    id: "street-photo",
    title: "街头摄影师镜头下的深夜城市，意外记录一场暖心接力",
    excerpt: "他本来只想拍一组夜景，却拍到了一位老人被陌生人接力护送回家的全过程。",
    category: "city",
    categoryName: "城市现场",
    author: "通讯员 · 陈屿",
    publishDate: "2026-09-10",
    readTime: "4 分钟",
    views: 39840,
    hot: false,
    featured: false,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20late-night%20city%20street%20with%20amber%20street%20lamps%2C%20wet%20pavement%20reflections%20and%20blurred%20lone%20pedestrian%2C%20cinematic%20editorial%20photography%2C%20crimson%20and%20gold%20palette%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=kldg-cover-10&orientation=landscape",
    tags: ["街头摄影", "城市温度", "深夜现场"],
    content: [
      "这位摄影师习惯在凌晨的城市里走动，用镜头记录空荡的街道。那天晚上，他在一个路口停了下来——一位老人站在原地，反复翻看着手里的纸条。",
      "他正准备上前，一位路过的年轻女孩先开了口。女孩帮老人看清了地址，又叫来同行的朋友一起对照地图。几个人在路灯下商量了几分钟，决定陪着老人走到下一个路口。",
      "到了路口，一位夜班的外卖骑手主动接上了“接力”。他说自己正好顺路，可以把老人送到小区门口。摄影师跟在后面，按下了几次快门。",
      "照片后来被发到了网上，配文只有一句：“这个城市没有想象中那么冷。”老人是否顺利到家，他没能确认，但他说，愿意相信答案是肯定的。",
    ],
  },
];